import {ICatalogo} from "./ICatalogo";

interface IColonia {
    id: number,
    nombreColonia: string,
    codigoPostal: string,
    pais: ICatalogo,
    estado: ICatalogo,
    ciudad: ICatalogo,
    nombre: string,
    descripcion: string
}

export class Colonia {
    direccion: string;
    direccionResumen: string;

    constructor(props: IColonia) {
        Object.assign(this, props);
        this.direccion = `${this.ciudad.nombre} ${this.estado.nombre} ${this.nombreColonia} ${this.codigoPostal}`;
        this.direccionResumen = `${this.codigoPostal} ${this.ciudad.nombre != null ?  this.ciudad.nombre : ''} ${this.estado.nombre != null ? this.estado.nombre : ''}`;
    }

    ObtenerIds() {
        return {
            paisId: this.pais.id,
            estadoId: this.estado.id,
            ciudadId: this.ciudad.id,
            codigoPostal: this.codigoPostal
        }
    }
}

export interface Colonia extends IColonia {
}
